import moment from "moment";
import onoPayout from "../../../../../assets/images/ono_payout.svg";
import { maskAccountNumber } from "../../../../../helpers/getText";
import { getCurrencyNumberWithOutSymbol, getCurrencyNumberWithSymbol } from "../../../../../helpers/get-currency-number";
import SelectDate from "../../../../../components/ui/select-date";
import { Input } from "../../../../../components/ui";
import { numberToWords } from "../../../../../components/number_to_word_converter/number_converter";
import RadioButtonBorder from "../../../../../components/ui/radio-button-border";
import PartnerInfo from "../../../../../components/home/partner";
import CustomDropdown from "../../../../../components/components-library/dropdown";
import useStep1 from "./useStep1";
import { useDispatch } from "react-redux";
import { setPayout } from "../payoutSlice";
import UserDetails from "../../../../../components/partner-info";
import { onoArkAccount } from '../../../../../constants/index'

const Step1 = () => {

    const pmtTypes = [
        { label: "Refund", value: "REFUND" },
        { label: "Loan Repayment", value: "LOANREPAYMENT" },
        { label: "Vendor Payment", value: "VENDORPAYMENT" },
    ];

    const dispatch = useDispatch();

    const {
        avlBal,
        payout,
        selectedBeneficiary
    } = useStep1();

    return (
        <div
            className="px-4 py-4 overflow-y-auto"
            style={{
                height: "calc(100vh - 9rem)",
            }}
        >
            <span className="font-semibold fs-14">From</span>
            <div className="flex border rounded-md p-2 mt-1 bg-white justify-between">
                <div className="flex items-center">
                    <img src={onoPayout} className="w-12 h-12 br-100" alt="" />
                    <div className="ml-2 flex flex-col">
                        <span className="font-semibold fs-14">
                            {onoArkAccount?.accountName}
                        </span>
                        <span className="fs-12 color-sub-text">
                            {maskAccountNumber(onoArkAccount?.accountNumber || '')}
                        </span>
                        <span className="fs-12 color-sub-text">
                            {onoArkAccount?.bankName}
                        </span>
                    </div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <span className="fs-12 color-sub-text"> Balance Available: </span>
                    <span className="fs-14 font-semibold">
                        {getCurrencyNumberWithSymbol(avlBal, true)}
                    </span>
                </div>
            </div>

            <div className="flex gap-4 space_18">
                <div className="w-[50%]">
                    <span className="font-semibold fs-14">Payable To</span>
                    <div className="flex border rounded-md items-center gap-2 px-2 py-4 bg-white mt-2">

                        <div className="flex">
                            <UserDetails
                                profilePic={""}
                                name={selectedBeneficiary?.actHolder ?? ""}
                                partnerMobile={selectedBeneficiary?.mobile?.toString() ?? ""}
                                partnerId={selectedBeneficiary?.email}
                                partnerType={""}
                                partnetAddress={''}
                            />
                        </div>
                    </div>
                </div>

                <div className="w-[50%]">
                    <span className="font-semibold fs-14">Fund Account ID</span>
                    <div className="border rounded-md items-center gap-2 px-2 py-4 bg-white mt-2">
                        <div className="fs-14 font-semibold">
                            {selectedBeneficiary?.rzpFa}
                        </div>
                        <div className="fs-12 color-sub-text font-medium">
                            {maskAccountNumber(selectedBeneficiary?.actNum || '')}
                        </div>
                    </div>
                </div>

            </div>
            <div className="flex gap-4 space_18 w-[100%]">
                <div className="relative w-[50%]">
                    <span className="font-semibold fs-14">
                        Select Date
                    </span>
                    <SelectDate
                        onChange={() => { }}
                        disabled={true}
                        selectedDate={payout?.calendarDate?.fromDate}
                    />
                </div>

                <CustomDropdown
                    label="Payment Type"
                    options={pmtTypes}
                    value={payout?.pmtType}
                    onChange={(value: any) => {
                        dispatch(setPayout({
                            ...payout,
                            pmtType: value
                        }))
                    }}
                    placeholder=""
                    className="flex-1"
                    required={true}
                />
            </div>

            <div className="flex gap-4 space_18 w-[100%]">
                <div className="relative w-[50%]">
                    <Input
                        type="number"
                        label={"Amount Paid"}
                        required={true}
                        value={payout?.amountPaid}
                        onChange={(e) => {
                            dispatch(setPayout({
                                ...payout,
                                amountPaid: e.target.value
                            }))
                        }}
                    />

                    <p className="fs-14 mt-1 color-primary">
                        {" "}
                        {numberToWords(payout?.amountPaid)}{" "}
                        {getCurrencyNumberWithOutSymbol(payout?.amountPaid) ? "Rupees Only" : ""}
                    </p>
                </div>

                <div className="relative w-[50%]">
                    <Input
                        type="text"
                        label={"Reference ID"}
                        palceholder="Reference ID (Optional)"
                        value={payout?.referenceId}
                        onChange={(e) => {
                            dispatch(setPayout({
                                ...payout,
                                referenceId: e.target.value
                            }))
                        }}
                    />
                </div>
            </div>

            <div className="space_18">
                <div className="fs-14 font-semibold">
                    Payment Mode<span className="color-red">*</span>
                </div>
                <div className="flex">
                    <RadioButtonBorder
                        displayType="horizontal"
                        data={[
                            { label: "NEFT", value: "NEFT" },
                            { label: "RTGS", value: "RTGS" },
                            { label: "IMPS", value: "IMPS" },
                        ]}
                        value={payout?.pmtMode}
                        pointer={{ label: "label", value: "value" }}
                        onChange={(selectedPaymentMode) => {
                            dispatch(setPayout({
                                ...payout,
                                pmtMode: selectedPaymentMode.toString()
                            }))
                        }}
                        styles={{ display: "flex", gap: "1rem", paddingTop: "0.5rem" }}
                    />
                </div>
                <div>
                    {(payout?.pmtMode == "IMPS" ||
                        payout?.pmtMode == "NEFT") && (
                            <span className="fs-14 font-semibold color-primary">
                                Rs. 1 Onwards
                            </span>
                        )}
                    {payout?.pmtMode == "RTGS" && (
                        <span className="fs-14 font-semibold color-primary">
                            Rs. 2 Lacs Onwards
                        </span>
                    )}
                </div>
            </div>

            <div className="space_18">
                <div>
                    <Input
                        type="text"
                        label={"Comments"}
                        value={payout?.comments}
                        onChange={(e) => {
                            dispatch(setPayout({
                                ...payout,
                                comments: e.target.value
                            }))
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
export default Step1;